import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M15.184 6.09a3.182 3.182 0 1 0-6.363 0V12a3.182 3.182 0 1 0 6.363 0z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12.002 3.818A2.273 2.273 0 0 0 9.73 6.091V12a2.273 2.273 0 0 0 4.545 0V6.09a2.273 2.273 0 0 0-2.273-2.272m-4.09 2.273a4.09 4.09 0 1 1 8.181 0V12a4.091 4.091 0 0 1-8.182 0z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.184 10.636a.91.91 0 0 1 .91.91 5.91 5.91 0 0 0 11.817 0 .91.91 0 0 1 1.819 0c0 3.96-2.98 7.224-6.819 7.674v1.87a.91.91 0 1 1-1.818 0v-1.87a7.73 7.73 0 0 1-6.818-7.675.91.91 0 0 1 .91-.909",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }